module.exports = __webpack_public_path__ + "static/media/23_WMATA - Washington, DC.cb3c2a04.jpg";